export default "__VITE_ASSET__DvHt9gRg__"